export const data_sharing_mixin = {
  inject: ['sharing_data'],
  data() {
    return {
      local_sharing_data: {},
    };
  },
  created() {
    this.local_sharing_data = this.sharing_data;
  },
  watch: {
    sharing_data: {
      deep: true,
      immediate: true,
      handler(val) {
        this.local_sharing_data = val;
      },
    },
  },
};
